module.exports = __webpack_public_path__ + "img/viber image 2019-04-08 , 19.09.18.885e6ea1.jpg";